import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import logo from "../assets/logoTransparent.png";
import { currentUser, logout, userLoggedIn } from "../pages/login/loginSlice";
import "./Header.scss";

function Header() {
    const dispatch = useAppDispatch();
    const isLoggedIn = useAppSelector(userLoggedIn);
    const user = useAppSelector(currentUser);
    const logoutUser = () => {
        dispatch(logout());
    }
    let userProfile = <></>;
    if (isLoggedIn) {
        userProfile = <>
            {user && <span className={"headerUsername"}>{user}</span>}
            <button onClick={() => {logoutUser()}}>Logout</button>
        </>;
    }
    return(<header>
        <Link to="/">
            <picture className={"headerLogo"}>
                <img src={logo} alt="Oh No! Not Another Email Client" />
            </picture>
        </Link>
        {userProfile}
    </header>)
}

export default Header;